exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BottomPanel {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 1040;\n    background: #fff;\n    box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n}\n\n.BottomPanel-close {\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    z-index: 100;\n    cursor: pointer;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/datatable/BottomPanel.css
// module id = 1101
// module chunks = 0